import lib from '@/library'
import Axios from 'axios'
import config from '@/config'
// import {localeProperties} from '@/library/locale/i18n'

let jackpotsRequestPromise = null

const state = {
  allGamesData: undefined,
  secureToken: undefined, // temporary token
  casinoGroups: undefined,
  casinoLicenseId: undefined,
  phrase: '',
  eventsLoaded: false,
  results: undefined,
  routeToExitSearch: '',
  launchGameWithGameIdAfterLogin: false,
  allJackpotsData: false,
  topGamesData: false,
  userRecentlyPlayedGames: false,
  RTPstore: null,
  jackpotsFromLocalStorage: false,
  marketingJackpots: false,
  recommendedGames: false,
  favoriteGames: false,
  navigation: false,
  providers: false
}

const getters = {
  getAllGamesData (state) {
    return state.allGamesData
  },
  getSecureToken (state) {
    return state.secureToken
  },
  getCasinoGroups (state) {
    return state.casinoGroups
  },
  getCasinoLicenseId (state) {
    return state.casinoLicenseId
  },
  getPhrase (state) {
    return state.phrase
  },
  getGamesLoaded (state) {
    return state.eventsLoaded
  },
  getResults (state) {
    return state.results
  },
  getRouteToExitSearch (state) {
    return state.routeToExitSearch
  },
  getLaunchGameWithGameIdAfterLogin (state) {
    return state.launchGameWithGameIdAfterLogin
  },
  getAllJackpotsData (state) {
    return state.allJackpotsData
  },
  getTopGamesData (state) {
    return state.topGamesData
  },
  getUserRecentlyPlayedGames (state) {
    return state.userRecentlyPlayedGames
  },
  getJackpotsFromLocalStorage (state) {
    return localStorage.getItem('casino_jackpots') ? JSON.parse(localStorage.getItem('casino_jackpots')) : false
  },
  getRTPstore (state) {
    return state.RTPstore
  },
  getMarketingJackpots (state) {
    return state.marketingJackpots
  },
  getRecommendedGames (state) {
    return state.recommendedGames
  },
  getFavoriteGames (state) {
    return state.favoriteGames
  },
  getNavigation (state) {
    return state.navigation
  },
  getProviders (state) {
    return state.providers
  }
}

const mutations = {
  setAllGamesData (state, data) {
    state.allGamesData = data
  },
  setSecureToken (state, data) {
    state.secureToken = data
  },
  setCasinoGroups (state, data) {
    state.casinoGroups = data
  },
  setCasinoLicenseId (state, data) {
    state.casinoLicenseId = data
  },
  setPhrase (state, phrase) {
    state.phrase = phrase.trim()
  },
  setGamesLoaded (state, value) {
    state.eventsLoaded = value
  },
  setResults (state, results) {
    state.results = results
  },
  setRouteToExitSearch (state, value) {
    state.routeToExitSearch = value
  },
  setLaunchGameWithGameIdAfterLogin (state, value) {
    state.launchGameWithGameIdAfterLogin = value
  },
  setAllJackpotsData (state, value) {
    state.allJackpotsData = value
  },
  setTopGamesData (state, value) {
    state.topGamesData = value
  },
  setUserRecentlyPlayedGamesData (state, value) {
    state.userRecentlyPlayedGames = value
  },
  setJackpotsFromLocalStorage (state, value) {
    localStorage.setItem('casino_jackpots', JSON.stringify(value))
  },
  setRTPstore (state, value) {
    state.RTPstore = value
  },
  setMarketingJackpots (state, value) {
    state.marketingJackpots = value
  },
  setRecommendedGames (state, value) {
    state.recommendedGames = value
  },
  setFavoriteGames (state, value) {
    state.favoriteGames = value
  },
  setNavigation (state, value) {
    state.navigation = value
  },
  setProviders (state, value) {
    state.providers = value
  }
}

const actions = {
  fetchAllGames (context, gameInfo = true) {
    return new Promise((resolve) => {
      lib.kansas.gapAllGames({
        gameGroup: 'gamegroup',
        withGameInfo: gameInfo
      }).then(response => {
        if (response && response.data) {
          context.commit('setAllGamesData', response.data)
          context.commit('setCasinoLicenseId', response.data.licenseId)
          context.commit('setProviders', response.data.providers)
        }
      }).catch((error) => {
        console.log('gap error', error)
      })
    })
  },
  async fetchSecureToken (context) {
    let response
    try {
      response = await lib.rpcService.callBroker('gap', 'gettoken')
      return response.result
    } catch (exception) {
      return exception
    }
  },
  fetchSearchResults (context) {
    // search for a game, group, type or provider
    context.commit('setGamesLoaded', false)
    let path = config.app.autoconf.WEB_SERVER_HOSTNAME.endsWith('/') ? config.app.autoconf.WEB_SERVER_HOSTNAME.slice(0, -1) : config.app.autoconf.WEB_SERVER_HOSTNAME
    Axios.get(path + '/gapapi/v1/search?query=' + state.phrase)
      .then((response) => {
        if (response && response.data) {
          let games = response.data.games
          if (games && games.length === 0) {
            context.commit('setResults', false)
            return false
          }
          let parseData = {
            groupId: games.length + Math.random(),
            gameIds: []
          }
          games.forEach(g => {
            if (!parseData.gameIds.includes(g.id)) {
              parseData.gameIds.push(g.id)
            }
          })
          context.commit('setResults', parseData)
          if (window.xtremepush || (config.app.autoconf.XTREMEPUSH_ANALYTICS && window.ctsautoconf.MOBILE_LS)) {
            let xtremeObj = {
              'param1': 'event',
              'param2': 'casino_search',
              'param3': {
                'text_searched': state.phrase,
                'accountId': localStorage.customer || 'N/A'
              }
            }
            let event = {
              'event': 'casino_search',
              'gaEventAction': 'casino_search success',
              'gaEventLabel': state.phrase || 'N/A',
              'accountId': localStorage.customer || 'N/A'
            }
            context.dispatch('analyticsHandler', {'event': event, 'xtremeObj': xtremeObj}, { root: true })
          }
        } else {
          context.commit('setResults', undefined)
        }
      })
      .catch((error) => {
        context.commit('setResults', undefined)
        console.log('search by phrase error: (phrase: \'' + state.phrase + '\'): ' + error.message)
      })
      .finally(() => {
        context.commit('setGamesLoaded', true)
      })
  },
  clearCachedResults (context) {
    context.commit('setResults', undefined)
  },
  fetchGameInfo (context, id) {
    return lib.kansas.gapGame({
      game: 'game',
      gameId: id
    })
  },
  fetchAllJackpots (context) {
    // prevent multiple requests from any part of application (f.e. headlines and casino page)
    if (jackpotsRequestPromise) {
      return jackpotsRequestPromise
    }
    const storedJackpots = context.getters['getAllJackpotsData']
    if (storedJackpots) {
      return Promise.resolve(storedJackpots)
    }
    jackpotsRequestPromise = lib.kansas.gapJackpots({ jackpots: 'jackpots' })
      .then(response => {
        if (response && response.data) {
          context.commit('setAllJackpotsData', response.data.jackpots)
          if (localStorage && !localStorage.casino_jackpots) {
            localStorage.casino_jackpots = JSON.stringify([])
          }
        }
        return response.data.jackpots
      })
      .catch(error => {
        console.error('gap jackpot error', error)
        throw error
      })
      .finally(() => {
        jackpotsRequestPromise = null
      })
    return jackpotsRequestPromise
  },
  fetchTopGames (context) {
    return new Promise((resolve) => {
      lib.kansas.gapTopGames({
        topgames: 'topgames'
      }).then(response => {
        if (response && response.data) {
          context.commit('setTopGamesData', response.data)
        }
      }).catch((error) => {
        console.log('gap top games error', error)
      })
    })
  },
  fetchUserRecentlyPlayedGames (context) {
    return lib.rpcService.callBroker('gap', 'getrecentlyplayed').then(response => {
      context.commit('setUserRecentlyPlayedGamesData', response.result)
      return response.result
    }).catch((error) => {
      console.log('gap recently played error', error)
      return error
    })
  },
  fetchMarketingJackpots (context) {
    lib.kansas.gapMarketingJackpots({}).then(response => {
      if (response && response.data) {
        context.commit('setMarketingJackpots', response.data.jackpots)
      }
    }).catch((error) => {
      console.log('gap error', error)
    })
  },
  fetchRecommendedGames (context) {
    return lib.rpcService.callBroker('gap', 'getrecommended').then(response => {
      context.commit('setRecommendedGames', response.result)
      return response.result
    }).catch((error) => {
      console.log('gap recently played error', error)
      return error
    })
  },
  fetchAllFavoriteGames (context) {
    return lib.rpcService.callBroker('gap', 'getallfavorites').then(response => {
      context.commit('setFavoriteGames', response.result)
      return response.result
    }).catch((error) => {
      console.log('gap all favorites error', error)
    })
  },
  addToFavorite (context, data) {
    lib.rpcService.callBroker('gap', 'addfavorite', {
      gameId: data
    }).then(response => {
      context.commit('setFavoriteGames', response.result)
    }).catch((error) => {
      console.log('gap add favorite error', error)
    })
  },
  removeFromFavorite (context, data) {
    lib.rpcService.callBroker('gap', 'removefavorite', {
      gameId: data
    }).then(response => {
      context.commit('setFavoriteGames', response.result)
    }).catch((error) => {
      console.log('gap remove favorite error', error)
    })
  },
  removeAllFavorites (context, data) {
    lib.rpcService.callBroker('gap', 'clearfavorites', {}).then(response => {
      console.log('CASINO21 remove all favorites', response)
      context.commit('setFavoriteGames', response.result)
    }).catch((error) => {
      console.log('gap remove all favorite error', error)
    })
  },
  fetchNavigation (context) {
    lib.kansas.gapNavigation({}).then(response => {
      if (response && response.data) {
        // let nav = (response.data.navigations && response.data.navigations[0]) || false
        context.commit('setNavigation', response.data.navigations)
      }
    }).catch((error) => {
      console.log('gap error', error)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/gap.js